import React, { useState, useEffect } from 'react';
import ReactApexChart from "react-apexcharts";

function AreaChart({ data, height, width }) {
  const [error, setError] = useState(null);
  const [options, setOptions] = useState({});
  const [series, setSeries] = useState([]);

  useEffect(() => {
    try {
      // Validate required fields
      if (!data || !Array.isArray(data.series) || !Array.isArray(data.labels)) {
        throw new Error("Invalid data format. 'series' and 'labels' must be arrays.");
      }

      setSeries(data.series);

      setOptions({
        chart: {
          type: 'area',
          zoom: {
            enabled: false
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'straight'
        },
        labels: data.labels,
      });

      setError(null);
    } catch (err) {
      console.error("AreaChart Error:", err);
      setError("Error generating chart. Please check the data.");
    }
  }, [data]);

  return (
    <div style={{ width, height }}>
      {error ? (
        <div style={{ color: 'red', padding: '10px' }}>{error + "Use Another favorite prompt to generate"}</div>
      ) : (
        <ReactApexChart
          dir="ltr"
          options={options}
          series={series}
          type="area"
          height={height}
          width={width}
          className="apex-charts"
        />
      )}
    </div>
  );
}

export default AreaChart;
